export const permissions = ['*'];

export default permissions;
